<template>
  <div class="popup-form-forgot-login-id">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div id="waiting" class="center" v-if="loading"></div>
      <div class="popup-header">
        <p class="title">
          ログインIDを忘れですか？
        </p>
        <p class="description">
          以下にメールアドレスをご入力の上、お送りください。 <br>
          お送りいただいたメール宛に通知します。
        </p>
      </div>
      <el-form :rules="rules" :model="inputForm" ref="inputForm" id="form" @submit.prevent="send('inputForm')">
        <el-form-item prop="mail_address" :error="message">
          <el-input :placeholder="$t('mail_address')" v-model.trim="inputForm.mail_address" name="mail_address"/>
        </el-form-item>
        <input type="hidden" name="_token" :value="csrf">
        <div class="form-footer mb-25">
          <el-button class="btn-login" @click="send('inputForm')">{{ $t('btn_send_mail') }}</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { requestForgotLoginId } from '../../api/auth'
  export default {
    props: {
      urls: { type: Object, required: true, default: [] },
      openFormForgotLoginId: { type: Boolean, required: true, default: false },
      site: { type: Number, required: false }
    },
    emits: ['isOpenNoti', 'closePopupForgotLoginId'],
    data() {
      return {
        outerVisible: false,
        innerVisible: false,
        dialog: '',
        inputForm: {
          mail_address: "",
        },
        rules: {
          mail_address: [
            { required: true, message: this.$t('errors.required', [this.$t('mail_address')]), trigger: 'blur' },
            { type: "email", message: this.$t('errors.mail'), trigger: 'blur' }
          ],
        },
        isClose: false,
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        loading: false,
        message: '',
      };
    },
    methods: {
      handleClose() {
        this.$emit('closePopupForgotLoginId');
      },

      send(formName) {
        document.querySelector(".el-dialog__body").classList.add("disabled");
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.message = '';
            requestForgotLoginId(this.urls.sendMailLoginId, this.inputForm)
            .then(response => response.json())
            .then(response => {
              if (response.status_code === 200) {
                this.handleClose();
                this.$emit('isOpenNoti');
              } else {
                this.message = response.message_error;
              }
            })
            .catch((error) => {})
            .finally(() => {
              document.querySelector(".el-dialog__body").classList.remove("disabled");
              this.loading = false;
            });
          } else {
            document.querySelector(".el-dialog__body").classList.remove("disabled");
            this.loading = false;
            return false;
          }
        });
      },
    },

    created() {
      this.dialog = this.openFormForgotLoginId;
    },
  }
</script>
<style lang="scss">
  .popup-form-forgot-login-id {
    .el-dialog {
      --el-dialog-width: 760px;
      --el-dialog-margin-top: 8vh;
      height: 611px;
      .el-dialog__body {
        margin-top: 10%;
      }
    }
    .dialog-partner {
      .el-dialog__body {
        margin-top: 0;
      }
    }
  }
</style>